/**
 * Lets blocking UI (e.g. Terms re-acceptance dialog) wait until COMO welcome / tour flow
 * has finished, so Radix Dialog is not opened under a higher z-index overlay.
 *
 * Uses synchronous listeners plus a completion gate so subscribers that mount after
 * dispatch still run (Terms may subscribe in an effect after onboarding dispatches).
 */
export const ONBOARDING_FLOW_COMPLETE_EVENT = 'coremonit:onboarding-flow-complete' as const;

type Listener = () => void;

const listeners = new Set<Listener>();

let onboardingCompleteGate = false;

/** Call when the signed-in user session ends so the next login can run onboarding again. */
export function resetOnboardingCompleteGate(): void {
  onboardingCompleteGate = false;
}

/** Subscribe to onboarding completion; returns unsubscribe. */
export function subscribeOnboardingFlowComplete(listener: Listener): () => void {
  listeners.add(listener);
  if (onboardingCompleteGate) {
    queueMicrotask(() => {
      try {
        listener();
      } catch {
        /* ignore */
      }
    });
  }
  return () => {
    listeners.delete(listener);
  };
}

export function dispatchOnboardingFlowComplete(): void {
  onboardingCompleteGate = true;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ONBOARDING_FLOW_COMPLETE_EVENT));
  }
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      /* avoid one bad listener breaking others */
    }
  });
}
